import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'jbc-front/components/Button';
import PayReportsCreateModal from '../containers/PayReportsCreateModalContainer';
import styles from './DownloadPayReports.scss';

const DownloadPayReports = ({
  isConfirmed,
  payrollRulesGroups,
  yearMonth,
  uniquePaymentDates,
  bulkModalOpen,
  openBulkModal,
  hideBulkModal,
  fetchZipJobStatus
}) => {
  const { t } = useTranslation();

  const openModal = () => {
    openBulkModal();
  };

  const hideModal = () => {
    hideBulkModal();
  };

  return (
    <>
      <div className={styles.button}>
        <Button disabled={!isConfirmed} onClick={openModal} primary widthWide>
          {t('features.EmployeePays.components.PayReportsCreateModal.Create_payslip_in_batch')}
        </Button>
      </div>
      {isConfirmed && (
        <PayReportsCreateModal
          isOpen={bulkModalOpen}
          hideModal={hideModal}
          isConfirmed={isConfirmed}
          payrollRulesGroups={payrollRulesGroups}
          paymentDate={yearMonth}
          uniquePaymentDates={uniquePaymentDates}
          fetchZipJobStatus={fetchZipJobStatus}
        />
      )}
    </>
  );
};

export default DownloadPayReports;